export default () => {
  const sections = document.querySelectorAll<HTMLElement>('.edo_section');
  if (sections) {
    sections.forEach((section) => {
      const resizeObserver = new ResizeObserver(() => orientationDetector(section));
      resizeObserver.observe(section);
    });
  }
};

const orientationDetector = (section: HTMLElement) => {
  const backgroundDecorator = section.querySelector<HTMLElement>('.edo_section__background-decorator');
  const container = backgroundDecorator?.querySelector<HTMLElement>('.container');
  if (backgroundDecorator && container) {
    const { width, height } = container.getBoundingClientRect();
    backgroundDecorator.style.setProperty('--circle-size', `${Math.max(width, height) + 200}px`);
  }
};
